import {useNavigate} from "react-router-dom";
import {useUserStore} from "../app/store/UserStore";

const LogOut = () => {
    const navigate = useNavigate();
    const userStore = useUserStore();
    try {
        userStore.logOut().then(() => {
            return navigate('/login');
        });
    } catch (e) {
        console.log(e.message);
        return navigate(-1);
    }
}
export default LogOut;